import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BigSpace from "./components/BigSpace";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BigSpace />} />
          <Route path="*" element={<BigSpace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
